(function () {
  'use-strict';

  angular.module('wsLrs.services').
  /**
   * A service which provides methods for setting, getting, updating, etc.
   * user preferences, stored as a cookie
   **/
  factory('UserPreferences', ['$cookies', function ($cookies) {
    var VALID_PREF_KEYS = ['listView'];
    return {
      cookieName: 'ws-user-preferences',
      userPreferences: null,
      exists: function exists() {
        return this.userPreferences !== null && this.userPreferences !== undefined;
      },
      create: function create() {
        var prefs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.userPreferences = {};
        for (var pref in prefs) {
          if (VALID_PREF_KEYS.includes(pref)) {
            this.userPreferences[pref] = prefs[pref];
          }
        }
        this.save();
      },
      readCookie: function readCookie() {
        this.userPreferences = $cookies.getObject(this.cookieName);
      },
      readCookieOrCreate: function readCookieOrCreate() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          alt = _ref.alt;
        this.readCookie();
        if (!this.exists()) {
          this.create(alt);
        }
      },
      ensureLoaded: function ensureLoaded() {
        if (!this.exists()) {
          this.readCookieOrCreate();
        }
      },
      get: function get() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$fresh = _ref2.fresh,
          fresh = _ref2$fresh === void 0 ? false : _ref2$fresh;
        this.ensureLoaded();
        if (fresh) {
          this.readCookie();
        }
        return this.userPreferences;
      },
      save: function save() {
        this.ensureLoaded();
        $cookies.putObject(this.cookieName, this.userPreferences, {
          secure: location.protocol === "https:"
        });
      },
      hasPreference: function hasPreference(pref) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$fresh = _ref3.fresh,
          fresh = _ref3$fresh === void 0 ? false : _ref3$fresh;
        this.ensureLoaded();
        var prefs = this.get({
          fresh: fresh
        });
        return prefs[pref] !== null && prefs[pref] !== undefined;
      },
      getPreference: function get(pref) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          alt = _ref4.alt,
          _ref4$fresh = _ref4.fresh,
          fresh = _ref4$fresh === void 0 ? false : _ref4$fresh;
        this.ensureLoaded();
        if (!this.hasPreference(pref)) {
          return alt;
        }
        return this.get({
          fresh: fresh
        })[pref];
      },
      setPreference: function setPreference(pref, val) {
        var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref5$fresh = _ref5.fresh,
          fresh = _ref5$fresh === void 0 ? false : _ref5$fresh,
          _ref5$save = _ref5.save,
          save = _ref5$save === void 0 ? true : _ref5$save;
        this.ensureLoaded();
        this.get({
          fresh: fresh
        })[pref] = val;
        if (save) {
          this.save();
        }
      }
    };
  }]);
})();
